import type { ApiClient } from "../../api";
import * as sdk from "../../api/generated";
import { idempotencyHeaders } from "../../api/idempotency";

export type ApprovalTemplateInput =
  sdk.PostApiV1DocumentWorkflowApprovalTemplatesBody;
export type ApprovalTemplatePatch =
  sdk.PatchApiV1DocumentWorkflowApprovalTemplatesByTemplateBody;

/** Сгенерированный SDK проверяет запросы и ответы на границе HTTP. */
export class ApprovalsApi {
  constructor(private readonly client: ApiClient) {}

  async templateCandidates(access_scope_id: string) {
    return (
      await sdk.getApiV1DocumentWorkflowApprovalTemplatesCandidates(
        this.client,
        { query: { access_scope_id } },
      )
    ).data;
  }

  async candidates(document: string) {
    return (
      await sdk.getApiV1DocumentWorkflowDocumentsByDocumentParticipantCandidates(
        this.client,
        { path: { document }, query: { purpose: "approval" } },
      )
    ).data;
  }

  async documentApprovals(document: string) {
    return (
      await sdk.getApiV1DocumentWorkflowDocumentsByDocumentApprovals(
        this.client,
        { path: { document } },
      )
    ).data;
  }

  async approval(approval: string) {
    return (
      await sdk.getApiV1DocumentWorkflowApprovalsByApproval(this.client, {
        path: { approval },
      })
    ).data;
  }

  async start(
    document: string,
    body: sdk.PostApiV1DocumentWorkflowDocumentsByDocumentApprovalsBody,
    key: string,
  ) {
    return (
      await sdk.postApiV1DocumentWorkflowDocumentsByDocumentApprovals(
        this.client,
        { path: { document }, body, headers: idempotencyHeaders(key) },
      )
    ).data;
  }

  async decide(
    approval: string,
    body: sdk.PostApiV1DocumentWorkflowApprovalsByApprovalDecisionsBody,
    key: string,
  ) {
    return (
      await sdk.postApiV1DocumentWorkflowApprovalsByApprovalDecisions(
        this.client,
        { path: { approval }, body, headers: idempotencyHeaders(key) },
      )
    ).data;
  }

  async resubmit(approval: string, key: string) {
    return (
      await sdk.postApiV1DocumentWorkflowApprovalsByApprovalResubmit(
        this.client,
        { path: { approval }, headers: idempotencyHeaders(key) },
      )
    ).data;
  }

  async withdraw(approval: string, key: string) {
    return (
      await sdk.postApiV1DocumentWorkflowApprovalsByApprovalWithdraw(
        this.client,
        { path: { approval }, headers: idempotencyHeaders(key) },
      )
    ).data;
  }

  tasks(query: sdk.GetApiV1DocumentWorkflowApprovalTasksQuery = {}) {
    return sdk.getApiV1DocumentWorkflowApprovalTasks(this.client, { query });
  }

  templates(query: sdk.GetApiV1DocumentWorkflowApprovalTemplatesQuery = {}) {
    return sdk.getApiV1DocumentWorkflowApprovalTemplates(this.client, {
      query,
    });
  }

  async template(id: string) {
    return (
      await sdk.getApiV1DocumentWorkflowApprovalTemplatesByTemplate(
        this.client,
        {
          path: { template: id },
        },
      )
    ).data;
  }

  async createTemplate(body: ApprovalTemplateInput, key: string) {
    return (
      await sdk.postApiV1DocumentWorkflowApprovalTemplates(this.client, {
        body,
        headers: idempotencyHeaders(key),
      })
    ).data;
  }

  async updateTemplate(id: string, body: ApprovalTemplatePatch, key: string) {
    return (
      await sdk.patchApiV1DocumentWorkflowApprovalTemplatesByTemplate(
        this.client,
        {
          path: { template: id },
          body,
          headers: idempotencyHeaders(key),
        },
      )
    ).data;
  }
}
